import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { FOOTER_GROUPS, BRAND, GET_STARTED_URL, BOOK_DEMO_URL, STARTUPFUEL_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { DgptLogo } from './DgptLogo';
const year = new Date().getFullYear();
export function DgptFooter() {
  const linkClass = 'text-sm text-text-secondary transition-colors hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-4 focus-visible:ring-offset-surface';
  return <footer className="border-t border-hairline bg-surface pb-24 sm:pb-0" data-id="element-66" data-mp="i4nzfu64held">
      <div className="mx-auto grid w-full max-w-[1320px] gap-12 px-4 py-14 sm:px-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] lg:px-8" data-id="element-67" data-mp="i2kzoif6473g">
        <div className="flex flex-col gap-4" data-id="element-68" data-mp="94irnix0oe6o">
          <DgptLogo data-id="element-69" data-mp="96c115z0lcid" />
          <div data-id="element-70" data-mp="4566d2lsnf67">
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-text-tertiary" data-id="element-71" data-mp="44mo1ks8eorn">DiligenceGPT™</p>
            <p className="mt-1 text-lg font-semibold tracking-[-0.015em] text-text-primary" data-id="element-72" data-mp="328qwr2xzxwey">{BRAND.positioning}</p>
            <p className="mt-1 text-sm text-text-secondary" data-id="element-73" data-mp="370h7vb4rco7f">{BRAND.footerLine}</p>
          </div>
          <div className="mt-2 flex flex-col gap-2 sm:flex-row" data-id="element-74" data-mp="2t9lv3nr51myk">
            <CtaButton href={GET_STARTED_URL} event="primary_cta_click" eventParams={{
            placement: 'footer',
            cta: 'get_started'
          }} data-id="element-75" data-mp="2x9e8cdrh8ha9">
              Get Started
              <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-76" data-mp="3l09yl6gab4fe" />
            </CtaButton>
            <CtaButton href={BOOK_DEMO_URL} event="enterprise_demo_click" eventParams={{
            placement: 'footer'
          }} variant="outline" data-id="element-77" data-mp="3pxs4enz093j6">
              Book a Demo
            </CtaButton>
          </div>
        </div>

        <nav aria-label="Footer" className="grid grid-cols-2 gap-8 sm:grid-cols-4" data-id="element-78" data-mp="3gzznjfdmxnto">
          {FOOTER_GROUPS.map(group => <div key={group.title} data-id="element-79" data-mp="25igeh6ddiqn7">
              <h2 className="text-[11px] font-semibold uppercase tracking-[0.1em] text-text-tertiary" data-id="element-80" data-mp="25jhsnjport95">{group.title}</h2>
              <ul className="mt-4 flex flex-col gap-3" data-id="element-81" data-mp="b1q9nqbmejje">
                {group.links.map(link => <li key={link.label} data-id="element-82" data-mp="65hwgigzh0ev">
                    {link.href.startsWith('/') ? <Link to={link.href} className={linkClass} data-id="element-83" data-mp="1avge1zyijog">{link.label}</Link> : <a href={link.href} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-84" data-mp="3teei257pyx5r">{link.label}</a>}
                  </li>)}
              </ul>
            </div>)}
        </nav>
      </div>
      <div className="mx-auto w-full max-w-[1320px] border-t border-hairline-soft px-4 py-6 text-xs text-text-tertiary sm:px-6 lg:px-8" data-id="element-85" data-mp="3ek9nvoxgrov7">
        © {year}{' '}
        <a href={STARTUPFUEL_URL} target="_blank" rel="noopener noreferrer" className="font-medium text-text-secondary underline-offset-4 hover:text-text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-86" data-mp="1crv8awie6why">
          StartupFuel
        </a>
        . {BRAND.product} by StartupFuel.
      </div>
    </footer>;
}